// extracted by mini-css-extract-plugin
module.exports = {"section":"Bank-section_ec6b07c6","title":"Bank-title_8fb68c36","row":"Bank-row_7d0da4f1","isForeign":"Bank-isForeign_5e258256"};